import React from 'react';

import { Chip, Paper, Stack, Typography } from '@mui/material';

import { ValidationResult } from './types';

const CARD_SX = { flex: 1, p: 3, border: 1, borderColor: 'grey.200', borderRadius: 2 } as const;

interface Props {
  validationResult: ValidationResult;
}

export default function ValidationSummaryCards({ validationResult }: Props) {
  return (
    <Stack direction="row" spacing={2}>
      <Paper elevation={0} sx={CARD_SX}>
        <Typography variant="body2" color="text.secondary" mb={1}>
          Upload ID
        </Typography>
        <Typography variant="body1" fontFamily="monospace">
          {validationResult.batchId ?? 'N/A'}
        </Typography>
      </Paper>
      <Paper elevation={0} sx={CARD_SX}>
        <Typography variant="body2" color="text.secondary" mb={1}>
          Phase
        </Typography>
        <Chip
          label={validationResult.phase === 'format' ? 'Format Validation' : 'Database Validation'}
          color={validationResult.phase === 'format' ? 'warning' : 'info'}
        />
      </Paper>
      <Paper elevation={0} sx={CARD_SX}>
        <Typography variant="body2" color="text.secondary" mb={1}>
          Total Rows
        </Typography>
        <Typography variant="h4" fontWeight={600}>
          {validationResult.totalRows}
        </Typography>
      </Paper>
      <Paper elevation={0} sx={CARD_SX}>
        <Typography variant="body2" color="text.secondary" mb={1}>
          Valid
        </Typography>
        <Typography variant="h4" fontWeight={600} color="success.main">
          {validationResult.validCount}
        </Typography>
      </Paper>
      <Paper elevation={0} sx={CARD_SX}>
        <Typography variant="body2" color="text.secondary" mb={1}>
          Errors
        </Typography>
        <Typography variant="h4" fontWeight={600} color="error.main">
          {validationResult.errorCount}
        </Typography>
      </Paper>
    </Stack>
  );
}
